import { call, put, takeEvery } from 'redux-saga/effects';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';
import * as types from './ShareLinksActionType';
import * as actions from './ShareLinksActions';
import * as services from './ShareLinksServices';

function* fetchShareLinksSaga(action) {
    try {
        const response = yield call(services.fetchMyLinks, action.payload.includeRevoked);
        if (response?.success) {
            yield put(actions.fetchShareLinksSuccess(response.values || response.value || []));
        } else {
            const err = response?.errorMessage || 'Failed to load links';
            yield put(actions.fetchShareLinksFailure(err));
            SweetAlert.error({ text: err });
        }
    } catch (error) {
        const err = error.message || 'Failed to load links';
        yield put(actions.fetchShareLinksFailure(err));
        SweetAlert.error({ text: err });
    }
}

function* revokeLinkSaga(action) {
    try {
        const { shareLinkId, includeRevoked } = action.payload;
        const response = yield call(services.revokeLink, shareLinkId);
        if (response?.success) {
            yield put(actions.revokeLinkSuccess());
            SweetAlert.success({ text: 'Link revoked.' });
            yield put(actions.fetchShareLinksRequest(includeRevoked));
        } else {
            const err = response?.errorMessage || 'Failed to revoke link';
            yield put(actions.revokeLinkFailure(err));
            SweetAlert.error({ text: err });
        }
    } catch (error) {
        const err = error.message || 'Failed to revoke link';
        yield put(actions.revokeLinkFailure(err));
        SweetAlert.error({ text: err });
    }
}

function* generateLinkSaga(action) {
    try {
        const response = yield call(services.generateLink, action.payload);
        if (response?.success) {
            yield put(actions.generateLinkSuccess((response.values || response.value)?.token || ''));
        } else {
            const err = response?.errorMessage || 'Failed to generate link';
            yield put(actions.generateLinkFailure(err));
            SweetAlert.error({ text: err });
        }
    } catch (error) {
        const err = error.message || 'Failed to generate link';
        yield put(actions.generateLinkFailure(err));
        SweetAlert.error({ text: err });
    }
}

export default function* shareLinksWatcher() {
    yield takeEvery(types.FETCH_SHARE_LINKS_REQUEST, fetchShareLinksSaga);
    yield takeEvery(types.REVOKE_LINK_REQUEST, revokeLinkSaga);
    yield takeEvery(types.GENERATE_LINK_REQUEST, generateLinkSaga);
}
